export const formatToCurrency = (
  value: number,
  currency?: Intl.NumberFormatOptions["currency"],
) => {
  if (typeof value === "number") {
    return value.toLocaleString("en-US", {
      style: "currency",
      currency: currency || "USD",
    });
  }

  return value;
};
